import script from "./ProductionInfoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductionInfoCard.vue?vue&type=script&setup=true&lang=js"

import "./ProductionInfoCard.vue?vue&type=style&index=0&id=95a43134&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95a43134"]])

export default __exports__
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QList from 'quasar/src/components/item/QList.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCardSection,QList,QInnerLoading});
